'use strict';

// Applies an image transition effect as images come into view
module.exports = {
    init: function () {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-in');
                }
            });
        }, {
            root: null, // Use the viewport as the root
            rootMargin: '0px', // No margin to adjust the intersection
            threshold: 0.5 // Trigger when 50% of the image is visible
        });

        const images = document.querySelectorAll('.js-image-transition');
        images.forEach(image => {
            observer.observe(image);
        });
    }
};
